import { connect, MapStateToProps } from 'react-redux';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import { getModuleDataByModuleType } from '../../../../selectors/modules';
import { ModuleType } from '../../../../../types/modules';
import { AppState } from '../../../../../types/store';
import { Props } from './ShopCommissions';

type StateProps = Pick<Props, 'isOpenForCommissions' | 'isOwner'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const { isOpenForCommissions } = getModuleDataByModuleType(
    state,
    ModuleType.COMMISSIONS
  );
  return {
    isOpenForCommissions,
    isOwner: isCurrentUserProfileOwner(state),
  };
};

export default connect(mapStateToProps);
